import { Box, useTheme } from "@mui/material";
import CreateQRForm from "app/components/QRList/CreateQRForm";
import { useGetQRDetailByIdQuery } from "lib/features/qrList/qrListService";
import { useLocation, useParams } from "react-router-dom";

const CreateQRList = () => {
  const theme = useTheme();
  const { id } = useParams();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const qrId = Number(queryParams.get("qr"));

  const { data: qrData, isLoading: qrLoading } = useGetQRDetailByIdQuery(
    {
      id: Number(qrId),
    },
    { skip: !qrId }
  );

  if (qrLoading) {
    return <></>;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      width="100%"
      marginY="1rem"
    >
      <Box
        sx={{
          maxWidth: {
            xs: "90vw", // small
            sm: "70vw", // tab
            md: "40vw", // large
          },
        }}
        width="100%"
        fontFamily={theme.typography.fontFamily}
      >
        {/* Form */}
        <CreateQRForm userId={Number(id)} qrcode={qrData} isEdit={!!qrId} />
      </Box>
    </Box>
  );
};

export default CreateQRList;
